<template>
    <div>
        <div class="sline"></div>
        <div class='loginBox'>
            <!-- 手机号输入项（原有） -->
            <div class="login-item">
                <label class="login-label">手机号</label>
                <div class="login-input-wrap">
                    <input
                            type="number"
                            placeholder="请输入手机号"
                            oninput="if(value.length>11)value=value.slice(0,11)"
                            @focus='instie'
                            v-model="telNumber"
                            class="login-input"
                    >
                    <p>
                        <span class='cancel' @click='toEmptyTel' v-show="telNumber"></span>
                    </p>
                </div>
            </div>
            <!-- 验证码输入项（原有） -->
            <!--<div>
                <label>验证码</label>
                <div>
                    <input
                            type="text"
                            placeholder="请输入验证码"
                            v-model='ercode'
                            maxlength="6"
                    >
                    <em @click.stop='toGetCode' :class="{disabled: isSend}">
                        {{isSend?second+'s':'获取验证码'}}
                    </em>
                </div>
            </div>-->
            <!-- 验证码输入项（核心优化：重构布局适配大字体） -->
            <div class="login-item">
                <label class="login-label">验证码</label>
                <div class="login-input-wrap code-wrap">
                    <input
                            type="text"
                            placeholder="请输入验证码"
                            v-model='ercode'
                            maxlength="6"
                            class="login-input"
                    >
                    <em
                            @click.stop='toGetCode'
                            :class="{disabled: isSend}"
                            class="code-btn"
                    >
                        {{isSend?second+'s':'获取验证码'}}
                    </em>
                </div>
            </div>
            <!-- 新增：密码设置项 -->
            <div class="login-item">
                <label class="login-label">设置密码</label>
                <div class="login-input-wrap">
                    <input
                            :type="showPwd ? 'text' : 'password'"
                            placeholder="6-18位字母、数字"
                            v-model='pwd'
                            maxlength="18"
                            class="login-input"
                    >
                    <!--<div class="pwdAction">-->
                        <em @click.stop='togglePwdShow' class="pwd-toggle">{{showPwd?'隐藏':'显示'}}</em>
                        <!--<span class='cancel' @click='toEmptyPwd' v-show="pwd"></span>-->
                    <!--</div>-->
                </div>
            </div>
        </div>
        <!-- 绑定按钮：需手机号+验证码+密码均输入完成才启用 -->
        <div class="loginBtn" :class="isEmpty?'':'blue'" @click='toBind'>绑定</div>
    </div>
</template>

<script>
    import { isPhone } from '@/utils/utils.js'
    import { mapActions } from 'vuex'
    export default {
        data() {
            return {
                isEmpty: true,    // 绑定按钮禁用状态
                telNumber: '',    // 手机号
                ercode: '',       // 验证码
                second: 60,       // 验证码倒计时
                isSend: false,    // 验证码是否已发送
                queryToken: '',   // 路由传参token
                // 新增：密码相关数据
                pwd: '',          // 设置的密码（登录名沿用手机号）
                showPwd: false,   // 密码是否显示
                timer: null       // 定时器实例（优化：统一管理，避免内存泄漏）
            };
        },
        created() {
            this.queryToken = this.$route.query.token
        },
        // 优化：组件销毁时清除定时器
        beforeDestroy() {
            this.timer && clearInterval(this.timer)
        },
        methods: {
            ...mapActions([
                'getSendBind',
                'bingingTel',
                'setLoginStus',
                'setNavRoute',
            ]),
            instie() {},
            // 获取验证码（原有逻辑，无修改）
            async toGetCode() {
                let tel = this.telNumber
                if (!tel) {
                    this.$toast('请输入手机号码')
                    return;
                } else if (!isPhone(tel)) {
                    this.$toast('手机号码格式错误')
                    return;
                }
                this.isSend = true
                this.startTimer() // 替换原有timer方法，优化定时器
                const res = await this.getSendBind({ mobile: tel })
                if (res.code == '1') {
                    this.checkInputStatus() // 刷新按钮状态
                    this.$toast('验证码发送成功')
                } else {
                    this.$toast(res.msg)
                    this.isSend = false // 发送失败重置倒计时状态
                }
            },
            // 核心：绑定手机号+设置密码（新增密码校验和参数传递）
            async toBind() {
                const tel = this.telNumber
                const ercode = this.ercode
                const pwd = this.pwd

                // 1. 手机号校验（原有）
                if (!tel) {
                    this.$toast('请输入手机号码')
                    return;
                } else if (!isPhone(tel)) {
                    this.$toast('手机号码格式错误')
                    return;
                }
                // 2. 验证码校验（原有）
                else if (!ercode) {
                    /*this.$toast('请输入验证码')
                    return;*/
                    //todo new 20260305 不校验验证码
                    this.ercode = '230102';
                }
                // 3. 新增：密码校验（与密码登录页规则一致）
                else if (!pwd) {
                    this.$toast('请设置登录密码')
                    return;
                } else if (!/^[a-zA-Z0-9_]{6,18}$/.test(pwd)) {
                    this.$toast('密码为6-18位字母、数字')
                    return;
                }

                // 组装请求参数：新增password字段，登录名=手机号（telNumber）
                let info = {
                    mobile: tel,
                    verification_code: ercode,
                    password: pwd, // 传递密码给后端，用于后续密码登录
                    // token: this.queryToken // 如需传token，解开注释即可
                }
                const res = await this.bingingTel(info)
                if (res.code == '1') {
                    // 绑定成功：更新本地用户信息，添加手机号（密码由后端存储）
                    let userInfos = JSON.parse(localStorage.getItem('userInfo') || '{}')
                    userInfos.mobile = tel
                    localStorage.setItem('userInfo', JSON.stringify(userInfos))
                    // 更新Vuex登录状态
                    this.setLoginStus(true)
                    this.setNavRoute()
                    this.$toast('绑定成功，已自动登录')
                } else {
                    this.$toast(res.msg)
                }
            },
            // 优化：合并原有getVal/getVal2，统一监听所有输入项状态
            checkInputStatus() {
                // 绑定按钮禁用条件：手机号/验证码/密码 任一为空
                //this.isEmpty = !this.telNumber || !this.ercode || !this.pwd
                //todo new 20260305 不校验验证码
                this.isEmpty = !this.telNumber || !this.pwd
            },
            // 清空手机号（原有）
            toEmptyTel() {
                this.telNumber = ''
                this.checkInputStatus()
            },
            // 新增：清空密码
            toEmptyPwd() {
                this.pwd = ''
                this.checkInputStatus()
            },
            // 新增：密码显示/隐藏切换
            togglePwdShow() {
                this.showPwd = !this.showPwd
            },
            // 优化：重构定时器，避免Promise冗余，统一管理
            startTimer() {
                this.timer && clearInterval(this.timer) // 清除旧定时器
                this.second = 60
                this.timer = setInterval(() => {
                    this.second--
                    if (this.second <= 0) {
                        clearInterval(this.timer)
                        this.second = 60
                        this.isSend = false
                        this.timer = null
                    }
                }, 1000)
            }
        },
        // 新增：监听所有输入项变化，自动更新按钮状态（替代原有@input绑定）
        watch: {
            telNumber: { handler: 'checkInputStatus', immediate: true },
            ercode: 'checkInputStatus',
            pwd: 'checkInputStatus'
        }
    };
</script>

<style scoped>
    /* 原有样式保留并优化 */
    .sline {
        width: 100%;
        height: 3.125rem; /* 替换固定px为rem：50px = 3.125rem（以16px为基准） */
    }
    .loginBox {
        padding: 0 0.75rem; /* 12px = 0.75rem */
        width: 100%; /* 关键：容器自适应宽度，不再限制内部元素 */
        box-sizing: border-box;
    }
    /* 优化登录项布局：统一样式，适配大字体 */
    .login-item {
        display: flex;
        align-items: left; /* 垂直居中，避免大字体下错位 */
        margin-bottom: 1.25rem; /* 20px = 1.25rem */
        width: 100%;
        box-sizing: border-box;
    }
    /* 标签样式优化：固定最小宽度，避免挤压 */
    .login-label {
        margin-bottom: 0;
        margin-right: 1.6875rem; /* 27px = 1.6875rem */
        color: #666;
        white-space: nowrap;
        min-width: 5rem; /* 80px = 5rem，固定最小宽度，对齐更稳定 */
        flex-shrink: 0; /* 关键：标签不收缩，避免被挤压 */
        font-size: 0.875rem; /* 14px = 0.875rem，适配大字体 */
    }
    /* 输入框容器：自适应宽度，flex布局优化 */
    .login-input-wrap {
        flex: 1; /* 关键：占满剩余宽度，不再固定320px */
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-width: 0; /* 解决flex子元素溢出问题 */
        padding: 0 0.25rem;
        box-sizing: border-box;
    }
    /* 验证码行特殊适配：防止按钮被挤出 */
    .code-wrap {
        flex-wrap: wrap; /* 关键：空间不足时自动换行 */
        gap: 0.5rem; /* 8px = 0.5rem，换行后间距 */
    }
    /* 输入框样式优化 */
    .login-input {
        flex: 1; /* 输入框自适应 */
        min-width: 9.375rem; /* 150px = 9.375rem，最小宽度避免过窄 */
        -webkit-user-select: text !important;
        border: none;
        outline: none;
        font-size: 0.875rem; /* 14px = 0.875rem，适配大字体 */
        color: #333;
        padding: 0.3125rem 0; /* 5px = 0.3125rem，增加内边距 */
        box-sizing: border-box;
    }
    /* 核心：获取验证码按钮优化 */
    .code-btn {
        flex-shrink: 0; /* 关键：按钮不收缩 */
        min-width: 5rem; /* 80px = 5rem，最小宽度保证文字完整 */
        min-height: 2.75rem; /* 44px = 2.75rem，符合移动端可点击区域标准 */
        line-height: 2.75rem; /* 垂直居中 */
        padding: 0 0.625rem; /* 10px = 0.625rem，左右内边距 */
        color: #00878b;
        font-size: 0.75rem; /* 12px = 0.75rem，相对单位 */
        cursor: pointer;
        text-align: center; /* 文字居中 */
        white-space: nowrap; /* 文字不换行 */
        border-radius: 0.25rem; /* 轻微圆角，提升体验 */
        background-color: transparent;
    }
    /* 倒计时禁用状态 */
    .code-btn.disabled {
        color: #999;
        pointer-events: none;
        background-color: #f5f5f5;
    }
    /* 绑定按钮优化 */
    .loginBtn {
        margin-top: 5rem; /* 80px = 5rem */
        width: 18.75rem; /* 300px = 18.75rem */
        height: 2.8125rem; /* 45px = 2.8125rem */
        line-height: 2.8125rem;
        background: #dedede;
        border-radius: 1.40625rem; /* 22.5px = 1.40625rem */
        color: #ffffff;
        letter-spacing: 0.1875rem; /* 3px = 0.1875rem */
        font-size: 1rem; /* 16px = 1rem */
        margin: 5rem auto 0;
        text-align: center;
        box-sizing: border-box;
    }
    .loginBtn.blue {
        background: #00878b;
    }
    /* 清空按钮优化 */
    .cancel {
        display: block;
        width: 1.25rem; /* 20px = 1.25rem */
        height: 1.25rem; /* 20px = 1.25rem */
        background-repeat: no-repeat;
        background-position: 50%;
        background-image: url('../assets/imgs/clear.png');
        background-size: 0.875rem 0.875rem; /* 14px = 0.875rem */
        cursor: pointer;
        flex-shrink: 0; /* 不收缩 */
    }
    /* 密码显示/隐藏按钮 */
    .pwd-toggle {
        color: #00878b;
        font-size: 0.75rem; /* 12px = 0.75rem */
        padding: 0 0.625rem; /* 10px = 0.625rem，左右内边距 */
        cursor: pointer;
        flex-shrink: 0;
        margin-right: 0.3125rem;
    }
</style>
<style src="../assets/login.css" scoped></style>


// WEBPACK FOOTER //
// src/components/login_bind.vue